import { GET_MY_ALERT_NOTIFICATION_DETAILS, SET_MY_ALERT_NOTIFICATION_DETAILS ,GET_DELETE_ALERT_NOTIFICATION_DETAILS,SET_DELETE_ALERT_NOTIFICATION_DETAILS, SET_DELETE_ALL_NOTIFICATIONS, SET_DELETE_ALL_ALERTS, GET_DELETE_ALL_NOTIFICATIONS, GET_DELETE_ALL_ALERTS, SET_IS_ALERT_NOTIFICATION_API_CALLED} from "./AlertNotificationType";
 const GetMyAlertNotificationDetails = (userId: any) => {
  return {
    
    type: GET_MY_ALERT_NOTIFICATION_DETAILS,
    notificationdetails: userId
  };
};
 const SetMyAlertNotificationtDetails = (notificationResponse: any) => {
  return {
    type: SET_MY_ALERT_NOTIFICATION_DETAILS,
    notificationdetails: notificationResponse,
  };
};
const GetDeleteAlertNotificationdetails = (deleteNotification:any) => {
  return {
    type: GET_DELETE_ALERT_NOTIFICATION_DETAILS,
    deletenotificationdetails:deleteNotification
  };
}
const SetDeleteAlertNotificationdetails = (deleteresponse :any) => {
  return {
    type: SET_DELETE_ALERT_NOTIFICATION_DETAILS,
    deletenotificationdetails: deleteresponse
  };
}
const GetDeleteAllNotifications = (email :any) => {
  return {
    type: GET_DELETE_ALL_NOTIFICATIONS,
    deleteAllNotifications: email
  };
}
const SetDeleteAllNotifications = (deleteAllNotifications: any) => {
  return {
    type: SET_DELETE_ALL_NOTIFICATIONS,
    deleteAllNotifications: deleteAllNotifications
  };
}
const GetDeleteAllAlerts = (email :any) => {
  return {
    type: GET_DELETE_ALL_ALERTS,
    deleteAllAlerts: email
  };
}
const SetDeleteAllAlerts = (deleteAllAlerts?: any) => {
  return {
    type: SET_DELETE_ALL_ALERTS,
    deleteAllAlerts: deleteAllAlerts
  };
}
const SetIsAlertNotificationApiCalled = (isAlertNotificationApiCalled?: any) => {
  return {
    type: SET_IS_ALERT_NOTIFICATION_API_CALLED,
    isAlertNotificationApiCalled
  };
}
export {
  GetMyAlertNotificationDetails,
  SetMyAlertNotificationtDetails,
  GetDeleteAlertNotificationdetails,
  SetDeleteAlertNotificationdetails,
  SetDeleteAllNotifications,
  SetDeleteAllAlerts,
  GetDeleteAllNotifications,
  GetDeleteAllAlerts,
  SetIsAlertNotificationApiCalled
}